import React        from "react";
import Flux         from "../../flux/Flux";
import Translations from "../../utils/Translations";


class NavbarSearchIcon extends React.PureComponent {

	constructor(props) {
		super(props);

		this.state = {currentSearchPattern: this.parsePattern(Flux.Search.getCurrentSearchPattern())};

		this.onCurrentSearchPatternChange = this.onCurrentSearchPatternChange.bind(this);
	}

	componentDidMount() {
		Flux.Search.addCurrentSearchpatternChangeListener(this.onCurrentSearchPatternChange);
	}

	componentWillUnmount() {
		Flux.Search.removeCurrentSearchpatternChangeListener(this.onCurrentSearchPatternChange);
	}

	parsePattern(pattern) {
		if (pattern && pattern.length > 16) {
			return pattern.substr(0, 13) + '...';
		}

		return pattern;
	}

	onCurrentSearchPatternChange() {
		this.setState({
			currentSearchPattern: this.parsePattern(Flux.Search.getCurrentSearchPattern()),
		});
	}

	handleClick() {
		Flux.GlobalSearch.showOverlay();
		document.querySelector('#navbar-search').classList.add('-hidden');
	}

	render() {
		const currentSearchPattern = this.state.currentSearchPattern ?
			<span className="navbar_search-text">{Translations.get('Search')}: "{this.state.currentSearchPattern}"</span>
			: null;

		return (
			<div className={"navbar_search-container -no-float" + (Flux.Guest.isLoggedIn() ? '' : ' -logged-in')}>
				<span className={"navbar_search-icon-dummy"} />
				<button className={"navbar_search-icon" + (this.state.currentSearchPattern ? ' -has-pattern' : '')} onClick={this.handleClick}>
					<span className="icon -icon-search-full" />
					{currentSearchPattern}
				</button>
			</div>);
	}

}

export default NavbarSearchIcon;
